module.exports = __webpack_public_path__ + "static/media/diagnosis.a5cf2068.svg";